import React, { useEffect, useContext, useReducer } from 'react';
import { M_Select, M_Table } from 'common/components';
import { api, process } from 'common/functions';
import { useApiCancel, useMount } from 'common/hooks';
import { produce } from 'immer';
import { ContentContext } from 'layout/admin/content/Content';
import type { Order, Pagination } from 'models';
import ReviewerTable from './ReviewerTable';

const initPagination = { info: { current: 1, total: 10 }, format: { limit: 20, offset: 0 } };
export type Data = {
  active: boolean;
  email: string;
  id: number;
  is_approve: boolean;
  name: string;
  phone_number: string;
  username: string;
};
export type Action =
  | { type: 'order'; payload: Order }
  | { type: 'setData'; payload: Data[] }
  | { type: 'searchKey'; payload: M_Select.item }
  | { type: 'searchText'; payload: symbol }
  | { type: 'init'; payload?: string }
  | { type: 'pagination'; payload: Pagination };

export interface State {
  data: Data[];
  header: M_Table.header[];
  order: Order;
  searchKey: M_Select.item;
  searchText: symbol;
  pagination: Pagination;
}

const initialState: State = {
  data: [],
  order: { username: 'DESC' },
  searchKey: { title: '선택', value: 'all' },
  searchText: Symbol(''),
  pagination: { ...initPagination },
  header: [
    { title: '아이디', property: 'username', flex: 2, order: true },
    { title: '이름', property: 'name', flex: 2, order: true },
    { title: '전화번호', property: 'phone_number', order: true },
    { title: '이메일', property: 'email', flex: 2, order: true },
    { title: '활성여부', property: 'active', flex: 2 },
  ],
};

// prettier-ignore
const reducer = (state: State, action: Action): State => {
  return produce(state, (draft) => {
    switch(action.type) {
      case 'setData': draft['data'] = action.payload; break
      case 'order': draft['order'] = action.payload; break;
      case 'searchKey':
        draft['searchKey'] = action.payload;
        if(action.payload.value === 'all') draft['searchText'] = Symbol('');
        draft.pagination.format['offset'] = 0;
        draft.pagination.info['current'] = 1;
        break;
      case 'searchText': 
        draft['searchText'] = action.payload; 
        draft.pagination.format['offset'] = 0;
        draft.pagination.info['current'] = 1;
        break;
      case 'pagination': draft['pagination'] = action.payload; break;
    }
  });
};

const CtReviewerTable: React.FC = () => {
  useApiCancel(['reviewers']);
  const { setLoading } = useContext(ContentContext);
  const [state, setState] = useReducer(reducer, initialState);

  const loadHandler = () => {
    setLoading(true);

    const sort = api.order(state.order);
    const params = {
      start: state.pagination.format.offset,
      count: state.pagination.format.limit,
      keyword_field: state.searchKey.value,
      keyword: state.searchText.description?.trim(),
      order_field: sort.key,
      order: sort.value,
    };

    process(
      api.reqData({ url: 'reviewers', params }),
      api.get.request,
      api.fullFilled(({ response }) => {
        if (response) {
          setState({ type: 'setData', payload: response.data.list });
          // setState({ type: 'pagination', payload: pagination });
        }
        setLoading(false);
      })
    );
  };

  useEffect(() => {
    loadHandler();
  }, []);

  useMount(() => {
    loadHandler();
  }, [state.order, state.searchText, state.pagination.info.current, state.searchKey]);

  return <ReviewerTable state={state} setState={setState} loadHandler={loadHandler} />;
};

export default CtReviewerTable;
